import { CreditCard } from "lucide-react";
import GenericPracticePage from "@/components/GenericPracticePage";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

const GreenCardRenewal = () => {
  const faqs = [
    {
      question: "Can I travel with an expired green card?",
      answer: "An expired green card doesn't affect your permanent resident status, but it can cause travel problems. Airlines may refuse boarding, and CBP may question you upon return. We recommend renewing early to avoid issues. If urgent travel is needed, we can help request expedited processing.",
    },
    {
      question: "How long does green card renewal take?",
      answer: "USCIS processing for Form I-90 typically takes 6-12 months. After filing, you'll receive a receipt notice that extends your green card validity for 24 months. This receipt allows you to work and travel while your renewal is pending.",
    },
  ];

  const mainContent = (
    <>
      <div className="prose prose-lg max-w-none mb-12">
        <h2 className="text-3xl font-bold mb-6">Keep Your Green Card Valid</h2>
        <p className="text-xl text-muted-foreground mb-8">
          Is your green card about to expire—or already expired? As a lawful permanent resident (LPR), it's essential to renew your Permanent Resident Card (Form I-551) to maintain valid proof of your legal status in the United States.
        </p>

        <h3 className="text-2xl font-bold mb-4">When to Renew</h3>
        <ul className="list-disc pl-6 mb-6">
          <li>10-year green cards should be renewed within 6 months of expiration</li>
          <li>Conditional 2-year green cards require filing to remove conditions (Form I-751), not renewal</li>
          <li>Lost, stolen, or damaged cards should be replaced immediately</li>
          <li>Address or name changes may require updating your card</li>
        </ul>

        <h3 className="text-2xl font-bold mb-4">Our Renewal Services</h3>
        <ul className="list-disc pl-6 mb-8">
          <li>Filing Form I-90 for green card renewal or replacement</li>
          <li>Gathering required documentation and photos</li>
          <li>Handling biometrics appointments</li>
          <li>Tracking application status</li>
          <li>Expediting when necessary</li>
          <li>Addressing any RFEs or complications</li>
        </ul>

        <h3 className="text-2xl font-bold mb-6">Frequently Asked Questions</h3>
        <Accordion type="single" collapsible className="w-full">
          {faqs.map((faq, index) => (
            <AccordionItem key={index} value={`item-${index}`}>
              <AccordionTrigger className="text-left">{faq.question}</AccordionTrigger>
              <AccordionContent className="text-muted-foreground">{faq.answer}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </>
  );

  return (
    <GenericPracticePage
      title="Green Card Renewal"
      subtitle="Renew or replace your permanent resident card (Form I-90)"
      icon={<CreditCard className="h-20 w-20 mx-auto mb-6 text-accent" />}
      mainContent={mainContent}
    />
  );
};

export default GreenCardRenewal;
